
export interface ErrorModelProps {
    key?: string;
    reasons?: string[];
}
export class ErrorModel {

    public key: string;
    public reasons: string[];

    constructor(errorModel?: ErrorModelProps) {

        if (errorModel) {
            this.key = errorModel.key ?? "";
            this.reasons = errorModel?.reasons ?? [];
        } else {
            this.key = "";
            this.reasons = [];
        }
    }
}